import script from "./DomainEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainEvents.vue?vue&type=script&setup=true&lang=js"

import "./DomainEvents.vue?vue&type=style&index=0&id=62b1c81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62b1c81c"]])

export default __exports__